<template>
  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat py-20"
    :style="{ backgroundImage: 'url(' + require(`@/assets/background.jpg`) + ')' }">
    <div class="w-full">
      <div class="pt-0 flex flex-col items-center max-h-full">
        <img class="pt-6 max-h-full object-contain w-10/12 md:w-6/12 lg:w-4/12" src="@/assets/logo.png" />

      </div>
    </div>
  </header>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'HeaderSectionExtranjeros',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>